export enum HouseVillasMenuEnum {
    overview = 0,
    independent_villas,
    governmental_villas,
    projects
}
